import script from "./SideBar.vue?vue&type=script&setup=true&lang=js"
export * from "./SideBar.vue?vue&type=script&setup=true&lang=js"

import "./SideBar.vue?vue&type=style&index=0&id=19134e5e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-19134e5e"]])

export default __exports__